<mat-button-toggle-group
  class="status-filter"
  [hideSingleSelectionIndicator]="true"
  [(ngModel)]="currentStatusFilter"
  aria-label="Status Filter">
  <mat-button-toggle
    (click)="onStatusFilterAction(tpaStatusFilter.Active)"
    [value]="tpaStatusFilter.Active"
    [matTooltip]="'Active'">
    <mat-icon class="active">fiber_manual_record</mat-icon>
  </mat-button-toggle>
  <mat-button-toggle
    (click)="onStatusFilterAction(tpaStatusFilter.Inactive)"
    [value]="tpaStatusFilter.Inactive"
    [matTooltip]="'Terminated'">
    <mat-icon class="error">fiber_manual_record</mat-icon>
  </mat-button-toggle>
  <mat-button-toggle
    (click)="onStatusFilterAction(tpaStatusFilter.Draft)"
    [value]="tpaStatusFilter.Draft"
    [matTooltip]="'Waiting'">
    <mat-icon class="warning">fiber_manual_record</mat-icon>
  </mat-button-toggle>
  <mat-button-toggle
    (click)="onStatusFilterAction(tpaStatusFilter.All)"
    [value]="tpaStatusFilter.All"
    [matTooltip]="'All Records'">
    All
  </mat-button-toggle>
</mat-button-toggle-group>
